import moment from 'moment'

const format = (date: string, format: string): string => {
  return moment(date).format(format)
}

export default { format }
